<template>
  <div>
    <nav-bar />
    <set-help :help="help" @close="help = undefined" @success="getHelp" />
    <b-container>
      <b-row>
        <b-col>
          <v-card>
            <v-card-title>
              <b-row align-v="center">
                <b-col cols="auto">
                  <v-btn class="v-primary" @click="$bvModal.show('set_help')">
                    <i class="fa fa-plus mr-1" /> Nova
                  </v-btn>
                </b-col>
                <b-col cols="auto"> AJUDA </b-col>
                <b-col>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    outlined
                    dense
                    hide-details
                  />
                </b-col>
              </b-row>
            </v-card-title>
            <v-card-text>
              <b-overlay :show="loading" opacity="0.99">
                <v-data-table
                  dense
                  :headers="headers"
                  :items="data"
                  :search="search"
                  :footer-props="{
                    'items-per-page-options': [25, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn small class="v-danger" @click="del(item.id)">
                      EXCLUIR
                    </v-btn>
                  </template>
                </v-data-table>
                <ErrorsMessages :errors="errors" />
              </b-overlay>
            </v-card-text>
          </v-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/components/ErrorsMessages";

import SetHelp from "../templates/help/set-help.vue";

import api from "../services/api";

import toast from "../components/ToastNotification";

export default {
  name: "Help",

  components: {
    NavBar,
    ErrorsMessages,
    SetHelp,
  },

  data() {
    return {
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Título", value: "title" },
        { text: "URL", value: "link" },
        { text: "Ações", value: "actions" },
      ],
      data: [],
      help: null,
    };
  },

  created() {
    this.getHelp();
  },

  methods: {
    async getHelp() {
      try {
        this.loading = true;

        const response = await api.get("/help");
        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async del(id) {
      try {
        this.loading = true;

        const params = { id };
        const response = await api.delete("/help", { params });
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.getHelp();
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>